/*
 * @Author: Zhouqi
 * @Date: 2025-11-08 15:27:00
 * @LastEditors: Claude
 * @LastEditTime: 2025-11-11
 */
import { UploadFile } from 'antd/es/upload';

// 导出校验相关类型
export * from './validator';

import { FileUploadRule } from './validator';

/**
 * 扩展的上传文件类型,包含上传进度
 */
export interface ExtendedUploadFile extends UploadFile {
  /** 上传进度 0-100 */
  uploadProgress?: number;
  /** 是否被选中（用于多图选择场景） */
  isSelected?: boolean;
  /** 错误信息（上传失败时的错误描述） */
  errorMessage?: string;
}

/**
 * 通用上传组件 Props
 */
export interface BaseUploadProps {
  children?: React.ReactNode;
  maxCount?: number;
  fileList?: ExtendedUploadFile[];
  onChange?: (fileList: ExtendedUploadFile[], file: ExtendedUploadFile) => void;
  disabled?: boolean;
  accept?: string;
  /** 文件校验规则 */
  rules?: FileUploadRule[];
  /** 校验失败回调（统一使用 string，不再使用 string[] ） */
  onValidationFailed?: (error: string) => void;
}

/**
 * 上传进度回调参数
 */
export interface UploadProgressData {
  progress: number;
  status: boolean;
  url: string;
}
